import { render, staticRenderFns } from "./SMSTeam.vue?vue&type=template&id=0a5fd4e0&"
import script from "./SMSTeam.vue?vue&type=script&lang=js&"
export * from "./SMSTeam.vue?vue&type=script&lang=js&"
import style0 from "./SMSTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports